import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Row as BasicRow } from '@/components/Row';

export const Row = styled(BasicRow)`
  margin: 1rem;

  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};

    a {
      color: ${theme.colors.primaryDark};
      text-decoration: underline;
    }

    ${theme.media.md.up} {
      max-width: '';
    }
  `}
`;

export const PhoneRow = styled(Row)`
  margin: 0;
`;

export const TitleWrapper = styled(Flex)<{ $isArchives?: boolean }>`
  ${({ theme, $isArchives }) => css`
    justify-content: ${$isArchives ? 'start' : 'center'};
    grid-gap: ${theme.spacing(5)};
  `}
`;
